module.exports = __webpack_public_path__ + "static/media/korsia.7a2c828e.jpg";